export default [
  {
    scrollBehavior(savedPosition){
      if (savedPosition){
        return savedPosition
      }
      else{
        return {x:0 , y:0}
      }
    },
    mode: 'history',
    path: '/product_car_list',
    name: 'product_car_list',
    component: () => import(/* webpackChunkName: "product_car_list" */ './ProductCarListV2')
  }
]
